import SnackbarProvider from './SnackbarProvider';

export default SnackbarProvider;
